import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Variable = function Variable(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19.9061 21C21.2464 18.2888 22 15.2329 22 12s-.7536-6.2888-2.0939-9M4.0939 3C2.7536 5.7112 2 8.7671 2 12s.7536 6.2888 2.094 9M16.5485 8.625h-.0896c-.6534 0-1.2742.287-1.6994.7857l-5.3749 6.3036a2.233 2.233 0 0 1-1.6994.7857h-.0897m1.1192-7.875h1.3941c.4997 0 .9388.333 1.0761.816l1.7744 6.2431c.1373.4829.5764.8159 1.0761.8159h1.3941"
    })
  }));
};
export default Variable;